import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import BackToTop from "../components/back-to-top"
import { Container, Row, Col } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Hero from "../components/hero-adjusted/hero"
import fracture from "../images/frac.jpg"

const Fractures = ({ location }) => {
  return (
    <Layout>
      <Seo title="FRACTURES & DISLOCATIONS" />
      {/* <div className="hero-adjustment">
        <div className="container">
          <div className="hero-content-wrapper">
            <div className="row no-gutters">
              <div className="col-12 col-md-7">
                <div className="hero-dog-bg">
                  <div className="dog-bg"></div>
                </div>
              </div>
              <div className="col-12 col-md-5">
                <div className="hero-video">
                  <div>
                    <div>
                      <div className="video-modal-btn no-video">
                        <LazyLoadImage
                          effect="blur"
                          src="/assets/img/tplo-video.jpg"
                          alt="video"
                          className="video-img img-fluid v-h"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inner-page-title text-right arthroscopy-hero noVideoInner">
              <h1>FRACTURES & DISLOCATIONS</h1>
            </div>
          </div>
        </div>
      </div> */}

      <div className="newPicModal">
        <Hero
          customPlayButton={true}
          location={location}
          videoImg={fracture}
          pageTitle="FRACTURES &
                DISLOCATIONS"
          scaled={true}
        />
      </div>
      <Container className="acl-container mt-5">
        <Row className="mb-3 pb-5 border-none">
          <Col lg={7} md={12}>
            <h4 className="mb-3">Overview</h4>
            <p>
              The word fracture as used in orthopedic surgery, essentially means
              “broken bone”. The word fracture does not imply the severity or
              lack of severity of the break. The most common cause of fractures
              in small animals involves some form of trauma such as being hit by
              an automobile. Virtually all bones are susceptible to fracture,
              but fractures of the long, weight bearing bones (humerus, radius,
              femur and tibia) and pelvis are most common. Simple non-displaced
              fractures can be repaired by external coaptation (splints and
              casts). Complicated and displaced fractures usually require some
              form of internal fixation such as plates, rods, nails, pins,
              wires, and screws for stabilization.
            </p>
            <p>
              The most important aspect of fracture management is to be certain
              no life threatening problems exist. Fractures, in and of
              themselves, are almost never life threatening but concurrent
              thoracic and abdominal trauma may be. Animals that have sustained
              major trauma should be taken to a general veterinarian or an
              emergency clinic immediately following trauma. Once the patient is
              stable and internal injuries have been ruled out or addressed,
              fracture repair options should be considered.
            </p>
          </Col>
          <Col lg={5} md={12}>
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img.jpg"
                alt="Arthroscopy"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5 border-none">
          <Col lg={7} md={12}>
            <h4 className="border-top pt-4 mb-3">Fracture classification</h4>
            <p>
              Fractures are classified by what bone is involved (example:
              femur), location of fracture (example: mid-shaft), morphology or
              configuration (example: spiral), multi-fragments (example:
              comminuted), if the skin has been penetrated (example: open) and
              joint involvement (intra-articular). An additional classification
              system is present for juvenile fractures involving the growth
              plates (physes). Moreover, complex classification systems exist
              for specific joint involvement and for open fractures. Fracture
              classification is useful in communication, fracture planning and
              prognosis.
            </p>
            <h4
              className="border-top pt-4 mb-3"
              style={{ borderTop: `1px solid #dedede` }}
            >
              Diagnosis of fractures
            </h4>
            <p>
              The diagnoses of fractures are based on physical examination
              followed by radiographs (X-rays). In some instances, a CT scan is
              indicated to identify all fracture fragments. CT scans are
              especially helpful in complicated pelvic fractures and fractures
              involving joints.
            </p>
          </Col>
          <Col lg={5} md={12}>
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-2.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5">
          <Col lg={7} md={12}>
            <h4 className="border-top pt-4 mb-3">
              Treatment options for fracture repair
            </h4>
            <p>
              Of course, the first question regarding fracture repair is does
              the patient require surgery or can the case be well managed with
              splints, casts and confinement. Non-displaced fractures,
              especially in young animals are often amendable to external
              support, also known as external coaptation (splints and casts).
              External coaptation has pros and cons like any treatment option.
              The pros are the patient avoids surgery and the initial cost is
              much less. The cons are splint management, fracture displacement
              and non-unions. Splints and cast are virtually always problematic
              in one way or another. Slippage, cast sores, vascular compromise
              and soiling are the most common problems. Splints and casts must
              be kept clean and dry and should be changed weekly or every-other
              week. Animals wearing splints or casts require confinement and
              Elizabethan collars should be used for the duration of healing
              (2-3 months on average). That said, there are situation where
              external coaptation is the best option, but it should not be
              looked at as an “easy fix”.
            </p>
            <p>
              Displaced fractures and those involving joints usually require
              internal fixation. Long bone fractures involving the weight
              bearing bones of the front or hind limbs, are typically repaired
              using bone plates, intramedullary nails, pins and wires and/or
              external fixators.
            </p>
          </Col>
          <Col lg={5} md={12}>
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-3.jpg"
                alt="Arthroscopy"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5">
          <Col lg={7} md={12}>
            <h4 className="pt-4 mb-3">Plate and Screw Fixation</h4>
            <p>
              Plate and screw fixation are arguably the most common form of
              fracture repair utilized in small animal orthopedics. Plates used
              for stabilizing fractures are made of surgical stainless steel or
              titanium and are fixated internally and held in place with bone
              screws. Newer plate technology involves locking screws that thread
              into both the bone and plates resulting in greater stability and
              shorter healing times. Plates come in a plethora of sizes both in
              thickness and length (figure 1). Figures 2-4 are examples of plate
              fixation. It is not uncommon to utilize individual bone screws in
              conjunction with plates.
            </p>
            <LazyLoadImage
              effect="blur"
              src="/assets/img/fracture-img-4.jpg"
              alt="Arthroscopy"
              className="img-fluid"
            />
            <p
              className="text-center mt-3"
              style={{ fontFamily: "Courgette", fontSize: "29px" }}
            >
              Figure 1
            </p>
          </Col>
          <Col lg={5} md={12} className="d-flex flex-column">
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-6.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-7.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5 border-none">
          <Col lg={7} md={12}>
            <h4 className="pt-4 mb-3">
              Interlocking, intramedullary (IM) nail fixation
            </h4>
            <p>
              Interlocking, intramedullary (IM) nailing is another established
              method used to align and stabilize canine fractures (figure 5).
              Unlike old style IM pins, threaded bolts are placed through holes
              in the ends of nails to provide rotational stability. This level
              of strength and stability are not possible with IM pins alone.
              Nails are inserted into the central canal of long bones of the
              extremities (e.g. femur, humerus, tibia) (figure 6).
            </p>
            <p>
              This system offers superior stability for highly comminuted (many
              pieces) long bone fractures as well as enabling the practice of
              biological repair (preserving fracture hematoma).{" "}
            </p>
            <LazyLoadImage
              effect="blur"
              src="/assets/img/fracture-img-9.jpg"
              alt="Arthroscopy"
              className="img-fluid"
            />
          </Col>
          <Col lg={5} md={12} className="d-flex flex-column">
            <div className="mb-4 text-center mt-4">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-8.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5">
          <Col md={7}>
            <h4 className="border-top pt-4 mb-3">External skeletal fixation</h4>
            <p>
              External skeletal fixation has been available to veterinarians for
              many years (figure 7). There has been a recent resurgence in the
              use of these devices, as surgeons are finding that minimally
              invasive reduction of bone fragments combined with rigid fixation
              provides a more biologic method of fixation for many fractures.
              External skeletal fixation is also used in conjunction with other
              repair methods such as IM pinning.
            </p>
            <div className="text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-10.png"
                alt="Arthroscopy"
                className="img-fluid mb-4"
              />
            </div>
            <p>
              External skeletal fixation involves pins placed percutaneously
              (through the skin), proximal and distal (above and below) to the
              fracture fragments and connected to an external frame. External
              skeletal fixation can be use for various types of fractures and is
              often used for complex procedures such as angular limb deformity
              and elbow incongruency correction and distraction osteosynthesis
              (figures 8 and 9).
            </p>
            <LazyLoadImage
              effect="blur"
              src="/assets/img/fracture-img-12.jpg"
              alt="Arthroscopy"
              className="img-fluid"
            />
          </Col>
          <Col md={5} className="d-flex flex-column">
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-11_op.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
              <p
                className="text-center mt-3"
                style={{ fontFamily: "Courgette", fontSize: "29px" }}
              >
                Figure 7 IMEX SK External Skeletal Fixation System Diagram
              </p>
            </div>
            <div className="mb-4">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-13.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 pb-5 border-none">
          <Col lg={7} md={12}>
            <h4 className="p pt-5 mb-3">
              Recovery and prognosis following fracture repair
            </h4>
            <p>
              Recovery, prognosis and time frame of healing following fracture
              repair is quite variable depending on the type of fracture and age
              of the patient. On average, fracture healing progresses gradually
              over a two to four-month period. During this postoperative period
              patient activity should be limited. Again, the degree of
              restrictions depends upon the fracture and fracture repair.
            </p>
          </Col>
          <Col lg={5} md={12} className="d-flex flex-column">
            <div className="text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-14.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-3 border-none">
          <Col lg={7} md={12}>
            <h4 className="border-top pt-4 mb-3">Joint dislocations</h4>
            <p>
              Joint dislocations, also called luxations, are common in
              veterinary orthopedics. Trauma is almost always the culprit
              although congenital patella luxations and congenital shoulder
              luxations in toy breed dogs are the exceptions.
            </p>
            <p>
              In the front limb elbow, luxations are most common but shoulder
              and carpal (wrist) joints also occur. In the hind limb, hip
              luxations are by far the most common but again, stifle (knee) and
              tarsal (ankle) joint luxations also occur. The diagnosis is based
              on physical examination and radiographs (X-rays). Treatment
              options are quiet variable depending on joint involved. Closed,
              non-surgical reduction is possible for some luxations.
            </p>
            <p>
              Hip or coxofemoral, luxations represent the most common canine
              joint luxation (Figure 10). Some are amendable to closed,
              non-surgical reduction, however recurrence is common. Surgical
              treatment is indicated in dogs with abnormal hip confirmation (hip
              dysplasia), in situations where a small bone fragments breaks off
              at the time of luxation and if closed, non-surgical treatment has
              failed either immediately or weeks later. In dogs with normal hip
              confirmation, open reductions and stabilization using an
              “artificial” ligament and toggle pin technique is indicated and
              carries a very good prognosis. In large breed dogs with abnormal
              hip confirmation, total hip replacement is the ideal treatment
              option with an excellent prognosis (Figure 11). In small breed
              dogs and cats, good to excellent results can be achieved by
              removing the femoral head (femoral head ostectomy or FHO).
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-land.jpg"
                alt="Arthroscopy Video"
                className="img-fluid mt-5"
              />
            </p>
          </Col>
          <Col lg={5} md={12} className="d-flex flex-column">
            <div className="mb-4 text-center">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-15.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
              <p
                className="text-right mb-1"
                style={{ fontFamily: "Courgette", fontSize: 25 }}
              >
                Figure 10: Hip Luxation
              </p>
            </div>
            <div>
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-15a.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
              <p
                className="text-right mb-1"
                style={{ fontFamily: "Courgette", fontSize: 25 }}
              >
                Figure 11: Hip Luxation repaired using a toggle pin technique
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mb-3 border-none">
          <Col lg={7} md={12}>
            <h4 className="border-top pt-4 mb-3">
              Prices for fracture fixation and joint dislocations are variable
              based on type of injury and procedure required for repair
            </h4>
            <p>
              Costs for fracture repair and joint luxations vary depending on
              the extent of the injury and the surgical procedure required. We
              will provide information about costs for your dog’s case at your
              consultation. Please feel free to contact us with questions.
            </p>
            <p>
              At Colorado Canine Orthopedics we are committed to providing only
              state of the art, non-compromised pet healthcare. We realize some
              pet owners may find this level of care relatively costly. However,
              despite the inherently expensive nature of our work, we are
              dedicated to providing the highest level of care at the most
              affordable price possible. We believe if you compare our fees to
              other specialty practices you will find this true.
            </p>
          </Col>
          <Col lg={5} md={12} className="d-flex flex-column">
            <div className="mb-4">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/fracture-img-16.jpg"
                alt="Arthroscopy Video"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
      <BackToTop />
    </Layout>
  )
}

export default Fractures
